var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 511,
    viewBox: "0 0 430 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2003_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.334 258.371C384.833 259.374 392.293 260.635 399.714 262.154V263.518C392.34 262.021 384.88 260.777 377.334 259.787C363.019 257.904 348.596 256.951 334.156 256.934H333.669C287.273 256.97 241.429 266.97 199.251 286.254C190.511 290.236 181.967 294.588 173.621 299.311C145.952 314.97 120.676 334.504 98.5618 357.319C83.6123 372.738 70.2145 389.584 58.5609 407.614C57.0832 409.892 55.6376 412.193 54.2239 414.515C48.5358 423.823 43.3228 433.412 38.6048 443.246C28.5129 464.287 20.7654 486.37 15.5012 509.097C15.3756 509.584 15.2648 510.078 15.154 510.572C15.1244 510.712 15.0875 510.859 15.0579 511L13.6172 510.675C13.6246 510.638 13.632 510.609 13.6394 510.572C13.7502 510.078 13.861 509.591 13.9792 509.097C19.3599 485.814 27.3091 463.197 37.6813 441.661V441.653C42.6577 431.289 48.1796 421.194 54.2239 411.411C55.6425 409.111 57.0881 406.828 58.5609 404.562C70.2112 386.683 83.5704 369.972 98.451 354.664C107.551 345.303 117.205 336.494 127.362 328.285L127.369 328.278C141.872 316.566 157.345 306.104 173.621 297.004C180.514 293.14 187.506 289.557 194.596 286.255C238.333 265.812 286.066 255.292 334.363 255.452C348.735 255.491 363.089 256.466 377.334 258.371Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.737 91.2124C243.9 91.2124 261.867 73.284 261.867 51.1682C261.867 29.0524 243.9 11.124 221.737 11.124C199.573 11.124 181.606 29.0524 181.606 51.1682C181.606 73.284 199.573 91.2124 221.737 91.2124Z",
    fill: "#FB3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8457 501.904C50.0973 506.52 54.3841 509.379 54.3841 509.379C54.3841 509.379 56.6418 504.753 55.3903 500.137C54.1387 495.52 49.8518 492.661 49.8518 492.661C49.8518 492.661 47.5942 497.287 48.8457 501.904Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6845 500.911C54.1188 504.247 54.5383 509.376 54.5383 509.376C54.5383 509.376 49.3897 509.095 45.9554 505.759C42.5211 502.423 42.1016 497.295 42.1016 497.295C42.1016 497.295 47.2502 497.575 50.6845 500.911Z",
    fill: "#335CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.156 501.904C145.408 506.52 149.695 509.379 149.695 509.379C149.695 509.379 151.952 504.753 150.701 500.137C149.449 495.52 145.162 492.661 145.162 492.661C145.162 492.661 142.905 497.287 144.156 501.904Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.995 500.911C149.429 504.247 149.849 509.376 149.849 509.376C149.849 509.376 144.7 509.095 141.266 505.759C137.832 502.423 137.412 497.295 137.412 497.295C137.412 497.295 142.561 497.575 145.995 500.911Z",
    fill: "#335CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.713 97.0424V144.717L377.334 159.772L344.455 181.875L307.92 206.447L250.585 177.842L178.142 141.702L163.055 134.174L147.968 122.127L194.552 80.6199L207.931 68.7C223.734 54.6207 244.179 46.8389 265.364 46.8389H349.402C356.009 46.8389 362.551 48.1374 368.655 50.6604C374.759 53.1834 380.305 56.8813 384.977 61.5431C389.649 66.205 393.355 71.7394 395.883 77.8304C398.412 83.9213 399.713 90.4496 399.713 97.0424Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.533 121.913L399.713 97.8564C438.495 240.607 441.665 378.614 399.713 510.609H371.571L370.056 509.098L330.824 469.957L308.053 447.235L308.651 442.855L310.72 427.793L315.264 394.668L320.221 358.528L325.179 322.395L330.137 286.255L334.156 256.934L334.363 255.452L335.094 250.115L340.052 213.974L344.455 181.874L345.01 177.841L348.659 151.241L350.174 140.197L377.334 122.127L377.533 121.913Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.966 122.125H377.334V510.612H147.966C122.921 368.465 116.626 235.789 147.966 122.125Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.248 415.749H236.996V510.612H279.248V415.749Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.662 358.53H173.618V394.669H348.662V358.53Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.032 444.876H287.399V460.284H362.032V444.876Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.041 444.876H154.408V460.284H229.041V444.876Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.662 286.254H173.618V322.392H348.662V286.254Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.662 213.977H173.618V250.115H348.662V213.977Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.662 141.7H173.618V177.839H348.662V141.7Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.713 509.098H0V510.572H399.713V509.098Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5602 338.854H54.2197V509.936H58.5602V338.854Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6188 360.656C98.8951 420.48 56.7156 469.171 56.7156 469.171C56.7156 469.171 14.0882 420.87 13.8119 361.046C13.5356 301.223 55.715 252.531 55.715 252.531C60.2036 236.681 108.23 265.918 98.6188 360.656Z",
    fill: "#335CFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M98.6188 360.656C98.8951 420.48 56.7156 469.171 56.7156 469.171C56.7156 469.171 14.0882 420.87 13.8119 361.046C13.5356 301.223 55.715 252.531 55.715 252.531C60.2036 236.681 108.23 265.918 98.6188 360.656Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13526 338.851H0V509.938H2.13526V338.851Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1952 360.659C93.0601 373.806 38.3956 405.012 28.2311 423.178V423.186C21.3781 438.784 12.6125 453.474 2.13526 466.92C0.960505 468.394 0.288159 469.168 0.288159 469.168L0 468.837V253.366C11.1933 267.142 20.5304 282.321 27.773 298.516V298.523C35.6343 316.085 19.7366 354.854 42.1952 360.659Z",
    fill: "#335CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.302 206.019C104.302 206.019 76.6991 205.776 42.5055 205.931C26.0737 206.005 11.1122 206.16 0 206.307V187.234C11.9545 178.1 27.7213 170.823 42.3873 179.065C71.2021 195.27 104.302 206.019 104.302 206.019Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.635 30.4636C132.444 30.6209 104.613 31.125 104.613 31.125C104.613 31.125 137.694 -12.5997 166.511 3.59999C195.327 19.7997 228.43 30.5555 228.43 30.5555C228.43 30.5555 200.826 30.3064 166.635 30.4636Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.453 45.4225L353.208 40.9457C365.863 40.3283 378.285 44.4979 387.994 52.6216C397.702 60.7453 403.981 72.2249 405.576 84.7669L416.706 172.253L377.614 121.957L377.533 121.913L260.552 61.3694L258.23 60.1681C251.13 56.4939 253.464 45.8127 261.453 45.4225Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.097 75.5107H233.465V90.9188H308.097V75.5107Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.282 405.963H244.556C220.371 311.749 220.371 219.346 244.556 128.755H279.282C301.388 222.75 302.181 315.209 279.282 405.963Z",
    fill: "#F9FAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2003_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 511,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCover);
export default __webpack_public_path__ + "static/media/login_cover.0af63f887011c98f91f6f16b9f90a927.svg";
export { ForwardRef as ReactComponent };